const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速秒开不缓冲',
    desc: '采用先进的视频分发技术与智能预加载算法，打开即播，告别转圈等待，观影体验丝滑流畅。',
  },
  {
    icon: 'ri-hd-line',
    title: '1080P 高清画质',
    desc: '全站影片支持 1080P 高清播放，画面清晰锐利，细节丰富，为您呈现影院级的视觉享受。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全设备完美适配',
    desc: '桌面、手机、平板全端覆盖，自适应屏幕尺寸，无论用哪种设备都能获得最佳观影体验。',
  },
  {
    icon: 'ri-refresh-line',
    title: '片源每日更新',
    desc: '专业内容团队每日精选更新，涵盖最新院线、经典修复、热门剧集，不漏掉任何一部好片。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            平台优势
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            为什么选择爱丫爱丫影院？四大核心优势为您揭晓
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((f) => (
            <article
              key={f.title}
              className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-7 text-center hover:border-accent-200/60 transition-all duration-300"
            >
              <span className="w-14 h-14 mx-auto flex items-center justify-center rounded-xl bg-accent-100">
                <i className={`${f.icon} text-2xl text-accent-600`}></i>
              </span>
              <h3 className="mt-5 font-heading text-base font-semibold text-foreground-950">
                {f.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                {f.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}